import { render, staticRenderFns } from "./ModalLabelProduct.vue?vue&type=template&id=0d5f3c56&scoped=true"
import script from "./ModalLabelProduct.vue?vue&type=script&lang=js"
export * from "./ModalLabelProduct.vue?vue&type=script&lang=js"
import style0 from "./ModalLabelProduct.vue?vue&type=style&index=0&id=0d5f3c56&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5f3c56",
  null
  
)

export default component.exports